<script setup>
import {computed, defineEmits, ref, watch} from 'vue';
    import {XMarkIcon} from '@heroicons/vue/20/solid';
    import {has} from 'lodash';

    const appName = process.env.APP_NAME;
    const assetUrl = process.env.ASSET_URL;

    const props = defineProps({
        src: String,
        imgClass: String,
        path: {
            type: String,
            required: false,
            default: '/storage/'
        },
        alt: {
            type: String,
            required: false,
            default: ''
        },
        fullPath: {
            type: String,
            required: false,
            default: null
        },
        hasAltField: {
            type: Boolean,
            required: false,
            default: false,
        },
        photoClass: {
            type: String,
            required: false,
            default: ''
        },
        containerClass: {
            type: String,
            required: false,
            default: ''
        },
        modelValue: String,
        placeHolder: String,
        setAltTextRef: Function,
    });

    const LABEL_ALT_TEXT = 'Image ALT Text'

    const emit = defineEmits([
        'delete-photo',
        'update:modelValue',
    ]);

    const imageSRC = computed(() => props.fullPath || assetUrl + props.path + props.src);

    const alt_text = ref(props.modelValue);

    watch(alt_text, (newValue) => {
       emit('update:modelValue', newValue);
    });

    watch(() => props.modelValue, (newValue) => {
       alt_text.value = newValue;
    });

    const deletePhoto = () => {
        emit('delete-photo');
    }
</script>

<template>
    <div :class="[containerClass]">
        <div>
            <button type="button"
                    class="p-1 text-gray-2 text-sm leading-tight flex items-center group"
                    @click="deletePhoto"
            >
                <div class="w-8 group-hover:rotate-360 group-hover:text-red transition-all duration-1000">
                    <x-mark-icon></x-mark-icon>
                </div>
                <div class="opacity-0 text-red group-hover:opacity-100 transition-opacity">Remove photo</div>
            </button>
        </div>
        <div :class="[photoClass]">
            <img :src="imageSRC" :alt="alt" :class="imgClass">
        </div>
        <div class="py-2" v-text="src"></div>

        <div class="form-row mt-4" v-if="hasAltField">
            <label for="" class="form-label" v-text="LABEL_ALT_TEXT"></label>
            <input type="text"
                   v-model="alt_text"
                   :ref="props.setAltTextRef"
                   :placeholder="placeHolder"
                   class="form-control"
                   autocomplete="off"
                   pattern="^[A-z0-9\x22&]+((\s|\.\s|,\s|-|\/|\s\/\s)[A-z0-9\x22&]+)*?\.?$"
            >
        </div>
    </div>

</template>

<style scoped lang="scss">
.photo {
    box-shadow: 0 0 0 0.5rem rgba(255,255,255, 0.5);
    -moz-box-shadow: 0 0 0 0.5rem rgba(255,255,255, 0.5);
    -webkit-box-shadow: 0 0 0 0.5rem rgba(255,255,255, 0.5);
    }
</style>
